import {isEmpty, map} from 'lodash';

import {
    Accordion,
    AccordionDetails,
    AccordionShortDetails,
    AccordionTitle,
    CardRow,
    DataWrapper
} from 'components';
import {OAuthClient} from 'types';

type Props = {
    loading?: boolean;
    clients: OAuthClient[];
    renderClientId: (clientId: string, labelPlacement?: 'left' | 'right') => JSX.Element;
    renderSecret: (client: OAuthClient) => JSX.Element;
    renderScopes: (client: OAuthClient, labelPlacement?: 'left' | 'right') => JSX.Element;
    renderCreated: (createdAt: Date) => string;
    renderUpdated: (updatedAt: Date) => string;
    renderActions: (client: OAuthClient) => JSX.Element;
};

export const OAuthAccordion = ({
    loading,
    clients,
    renderClientId,
    renderSecret,
    renderScopes,
    renderCreated,
    renderUpdated,
    renderActions
}: Props) => (
    <DataWrapper isLoading={loading} noData={isEmpty(clients)}>
        {map(clients, (client: OAuthClient) => (
            <Accordion key={client.id} className='tw-mb-2 lg:tw-hidden'>
                <AccordionTitle>
                    <div className='tw-flex tw-items-center tw-justify-between'>
                        <div className='tw-text-break-word tw-ts-base-bold'>{client.name}</div>
                        {renderActions(client)}
                    </div>
                </AccordionTitle>
                <AccordionShortDetails showExpanded className='tw-relative tw-min-h-6'>
                    <CardRow icon='id'>
                        {renderClientId(client.clientId, 'left')}
                    </CardRow>
                    <CardRow icon='lock'>
                        {renderSecret(client)}
                    </CardRow>
                </AccordionShortDetails>
                <AccordionDetails>
                    <CardRow icon='permission'>
                        {renderScopes(client, 'left')}
                    </CardRow>
                    <CardRow icon='calendar' className='tw-text-sm tw-text-default-dimmed'>
                        {renderCreated(client.createdAt)}
                    </CardRow>
                    {client.updatedAt &&
                        <CardRow icon='edit' className='tw-text-sm tw-text-default-dimmed'>
                            {renderUpdated(client.updatedAt)}
                        </CardRow>}
                </AccordionDetails>
            </Accordion>
        ))}
    </DataWrapper>
);